module.exports = __webpack_public_path__ + "static/media/Jennifer E.dcffffeb.jpg";